/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import { useAuditFilter } from "./hooks";
import GeneralFilter from "../../../Shared/Filter/GeneralFilter";
import { resetAuditFilters } from "../../../../store/filters/audit/reducers";

interface IAuditFilertProps {
  children?: React.ReactNode;
}

export const AuditFilter: React.FC<IAuditFilertProps> = ({ children }) => {
  const { dispatch, auditFilters, formControlSx } = useAuditFilter();

  return (
    <>
      <GeneralFilter
        dispatch={dispatch}
        filters={auditFilters}
        formControlSx={formControlSx}
        resetFilters={resetAuditFilters}
        isEnableApllFilter={false}
        searchTooltip="search audit trail..."
        searchWidth={320}>
        {children}
      </GeneralFilter>
    </>
  );
};

export default AuditFilter;
